export function getHeight(element: HTMLElement): number {
  const style = window.getComputedStyle(element);
  const height = parseFloat(style.getPropertyValue("height").replace("px", ""));
  return height;
}

/**
 * Get the height of a hidden HTML element.
 * @param element - The hidden HTML element whose height needs to be measured.
 * @returns The height of the hidden element.
 */
export function getHiddenElementHeight(
  element: HTMLElement,
): number {
  if (!element) {
    return 0;
  }

  const width = parseFloat(
    window.getComputedStyle(element).getPropertyValue("width").replace(
      "px",
      "",
    ),
  );

  // // Save the current styles
  const originalStyle = {
    display: element.style.display,
    visibility: element.style.visibility,
    position: element.style.position,
    height: element.style.height,
    minHeight: element.style.minHeight,
    width: element.style.width,
  };

  // // Apply temporary styles to measure the height
  element.style.display = "flex";
  element.style.position = "absolute";
  element.style.height = "auto";
  element.style.minHeight = "initial";
  element.style.width = `${width}px`;

  // // Get the height
  const style = window.getComputedStyle(element);
  const height = parseFloat(style.getPropertyValue("height").replace("px", ""));

  // // Restore the original styles
  element.style.display = originalStyle.display;
  element.style.position = originalStyle.position;
  element.style.height = originalStyle.height;
  element.style.minHeight = originalStyle.minHeight;
  element.style.width = originalStyle.width;

  return height;
}
